import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import SelectField from "components/SelectField";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
  width: 100%;
`;

type Props = {
  filters: { selected: boolean; value: string }[];
  setFilters: Function;
};

function Filters({ filters, setFilters }: Props): JSX.Element {
  const intl = useIntl();

  const checkedFilters = useMemo(() => {
    return filters
      ?.filter((filter) => filter.selected)
      .map((filter) => filter.value);
  }, [filters]);

  function handleChange(event: { target: { value: string } }) {
    event?.target?.value && setFilters(event?.target?.value);
  }

  if (!filters?.length) return <></>;

  return (
    <Container>
      <SelectField
        // @ts-ignore
        checkbox
        id="filters"
        label={intl.messages["parkStatisticsScene.filters.label"]}
        values={filters}
        checked={checkedFilters}
        onChange={handleChange}
      />
    </Container>
  );
}

export default Filters;
